import { monolithApiClient } from "#/src/configs/axios.config";
import { useQuery } from "@web-monorepo/fetchers";
import { paths } from "@web-monorepo/api-types";

type Endpoint = paths["/api/marketplace/parent/session-discount"]["get"];
type Response = Endpoint["responses"]["200"]["content"]["application/json"];

export type PromotionType = Response[number]["promotionType"];

export type SessionDiscount = Response[number];

export const SESSION_DISCOUNTS_QUERY_KEY = ["getSessionDiscounts"] as const;

const getSessionDiscounts = async (silentNetworkError = false) =>
  await monolithApiClient.get<Response>(`/parent/session-discount`, { silentNetworkError });

export default (options?: { enabled?: boolean; userId?: string }) => {
  return useQuery(
    options?.userId ? [...SESSION_DISCOUNTS_QUERY_KEY, options.userId] : SESSION_DISCOUNTS_QUERY_KEY,
    async () => (await getSessionDiscounts(Boolean(options?.userId))).data,
    {
      refetchOnWindowFocus: options?.userId ? "always" : false,
      ...(options?.userId ? { onError: () => undefined } : {}),
      refetchOnMount: false,
      enabled: options?.enabled ?? true,
    },
  );
};
